import request from "@/utils/request";

// 省
export function provinceApi(data) {
    return request({
        url: "/api/country/queryState",
        method: "get",
        params: data
    })
}
// 城市区域
export const cityApi = (data) => {
    return request({
        url: "/api/country/queryCity",
        method: "get",
        params: data
    })
}
//会员报表列表
export function getMemberReportFormList(data) {
    return request({
        url: "api/report/customerReportDetail",
        method: "post",
        data: data
    })
}
//会员报表统计
export function getMemberReportFormStatistics(data) {
    return request({
        url: "/api/report/customerReportStatics",
        method: "post",
        data: data

    })
}


// 会员报表导出
export function memberReportForm(data) {
    return request({
        url: "/api/report/customerReportExport",
        method: "POST",
        data: data
    });
}

//礼券报表列表
export function getcouponListDetail(data) {
    return request({
        url: "/api/report/couponListDetail",
        method: "post",
        data: data

    })
}

//礼券报表列表
export function couponListDetailExport(data) {
    return request({
        url: "/api/report/couponListDetailExport",
        method: "post",
        data: data

    })
}


// 会员开源开散 --- 区域
export function RegionApi(data) {
    return request({
        url: "/api/shop/queryRegion",
        method: "POST",
        params: data
    });
}
// 会员开源开散 --- 首页列表
export function customerDisperseDetailApi(data) {
    return request({
        url: "/api/report/customerDisperseDetail",
        method: "POST",
        data: data
    });
}
// 会员开源开散 --- 统计
export function customerDisperseStaticsApi(data) {
    return request({
        url: "/api/report/customerDisperseStatics",
        method: "POST",
        data: data
    });
}
// 会员开源开散 --- 导出
export function customerDisperseExportApi(data) {
    return request({
        url: "/api/report/customerDisperseExport",
        method: "post",
        data: data
    })
}

//当前用户报表导出记录列表
export function reportFormList(data) {
    return request({
        url: "/api/report/exportList",
        method: "POST",
        data: data
    });
}

// 客户心愿单列表
export function reportcustwishlistApi(data) {
    return request({
        url: "/api/report/custwishlist",
        method: "POST",
        data: data
    })
}

// 客户心愿单导出
export function reportcustwishlistExport(data) {
    return request({
        url: "/api/report/custwishlistExport",
        method: "POST",
        data: data
    })
}

// 改衣单列表
export function reportdresssOrderListApi(data) {
    return request({
        url: "/api/report/dresssOrderList",
        method: "POST",
        data: data
    })
}

// 改衣单导出
export function reportdresssOrderListExport(data) {
    return request({
        url: "/api/report/dresssOrderListExport",
        method: "POST",
        data: data
    })
}

// 获取报表显示列
export function ReportgetdisplayfiledApi(data) {
    return request({
        url: "/api/report/getdisplayfiled",
        method: "POST",
        data: data
    })
}

// 会员销售汇总报表
export function customerSaleReportDetailApi(data) {
    return request({
        url: "/api/report/customerSaleReportDetail",
        method: "POST",
        data: data
    })
}

// 会员销售报表统计
export function customerSaleReportStaticsApi(data) {
    return request({
        url: "/api/report/customerSaleReportStatics",
        method: "POST",
        data: data
    })
}

// 会员销售报表导出
export function customerSaleReportExportApi(data) {
    return request({
        url: "/api/report/customerSaleReportExport",
        method: "POST",
        data: data
    })
}

//会员消费同比列表
export function memberConsumptionReportApi(data) {
    return request({
        url: "api/report/saleReportDetail",
        method: "POST",
        data: data
    })
}

//会员消费同比数据导出
export function saleReportExportApi(data) {
    return request({
        url: "api/report/saleReportExport",
        method: "POST",
        data: data,
    })
}
//会员消费同比汇总数据
export function saleReportSumApi(data) {
    return request({
        url: "api/report/saleReportSum",
        method: "POST",
        data: data,
    })
}


//会员企业微信好友关系报表列表
export function EnterpriseWeChatFriendshipListApi(data) {
    return request({
        url: "api/report/qiYeFollowList",
        method: "POST",
        data: data
    })
}

//会员企业微信好友关系报表导出
export function EnterpriseWeChatFriendshipExportApi(data) {
    return request({
        url: "api/report/qiYeFollowExport",
        method: "POST",
        data: data,
    })
}

//月度同比会员销售数据分析
export function monthlyCustSalesDataAnalysisApi(data) {
    return request({
        url: "api/report/custConsumeAnalysis",
        method: "POST",
        data: data,
    })
}

export function reportMonthlyCustSalesDataAnalysisApi(data) {
    return request({
        url: "/api/report/custConsumeAnalysisExport",
        method: "POST",
        data: data
    });
}